import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Колесо года")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("все события")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("актуальные события")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("прошедшие события")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("по возрастанию даты")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("по убыванию даты")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_accordion = _resolveComponent("accordion")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, {
                size: "large",
                color: "dark"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select, {
                "interface-options": _ctx.customPopoverOptions,
                interface: "popover",
                placeholder: "фильтровать",
                slot: "end",
                value: "upToDate",
                modelValue: _ctx.filter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select_option, { value: "all" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select_option, { value: "upToDate" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select_option, { value: "past" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["interface-options", "modelValue"]),
              _createVNode(_component_ion_select, {
                "interface-options": _ctx.customPopoverOptions,
                interface: "popover",
                placeholder: "сортировать",
                slot: "end",
                value: "asc",
                modelValue: _ctx.sort,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sort) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select_option, { value: "asc" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select_option, { value: "desc" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["interface-options", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_accordion, {
            filter_type: this.filter,
            sort_type: this.sort
          }, null, 8, ["filter_type", "sort_type"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}